/* Balkan — panoul de cautare din header.

   Doua lucruri specifice, cerute de client:

   1. ZOOM. Panoul se mareste din butonul apasat si se micsoreaza inapoi in el la
      inchidere. Nu e o animatie generica de sus in jos: `transform-origin` se
      seteaza pe centrul butonului care a deschis panoul, calculat in procente
      fata de foaie. Asa, lupa de pe mobil si caseta lata de pe desktop dau
      fiecare alta traiectorie, iar ochiul urmareste acelasi obiect.

   2. SUGESTII REALE. La scriere, rezultatele vin din Predictive Search API-ul
      Shopify, randate de `sections/balkan-search-fragment.liquid` — deci
      preturile sunt formatate de Liquid, nu de JavaScript.

   Scriptul e inserat o singura data (panoul se randeaza o singura data), dar
   pastram santinela: `search.liquid` si sertarul pot ajunge sa il ceara din nou. */
(() => {
  if (window.__bkSearchReady) return;
  window.__bkSearchReady = true;

  const root = document.querySelector('[data-bk-search]');
  if (!root) return;

  const sheet = root.querySelector('[data-bk-srch-sheet]');
  const scrim = root.querySelector('[data-bk-srch-scrim]');
  const input = root.querySelector('[data-bk-srch-input]');
  const idle = root.querySelector('[data-bk-srch-idle]');
  const res = root.querySelector('[data-bk-srch-res]');
  const closeBtn = root.querySelector('[data-bk-srch-close]');

  let lastFocus = null;
  let seq = 0;
  let timer = null;
  const cache = new Map();

  /* Originea maririi = butonul apasat. Fara asta panoul ar creste din centrul
     ecranului, ceea ce rupe legatura cu ce a atins omul. */
  const setOrigin = (trigger) => {
    if (!trigger) { sheet.style.transformOrigin = '50% 0%'; return; }
    const t = trigger.getBoundingClientRect();
    const s = sheet.getBoundingClientRect();
    if (!s.width || !s.height) { sheet.style.transformOrigin = '50% 0%'; return; }
    const x = ((t.left + t.width / 2 - s.left) / s.width) * 100;
    const y = ((t.top + t.height / 2 - s.top) / s.height) * 100;
    sheet.style.transformOrigin = `${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`;
  };

  /* Cosul deschis (sertarul Horizon) statea peste panoul de cautare si ii fura
     focusul, deci cautarea parea moarta (28 oct. 2026). Il inchidem intai, prin
     butonul lui de inchidere, ca tema sa-si faca singura curatenia (voal, focus). */
  const closeDrawers = () => {
    document.querySelectorAll('dialog.theme-drawer__dialog').forEach((d) => {
      if (!d.open || !d.getBoundingClientRect().width) return;
      const x = d.querySelector('.theme-drawer__close-button');
      if (x) x.click();
      else if (typeof d.close === 'function') d.close();
    });
  };

  const open = (trigger) => {
    if (!root.hidden) return;
    closeDrawers();
    lastFocus = trigger || document.activeElement;
    root.hidden = false;
    setOrigin(trigger);
    document.documentElement.classList.add('bk-noscroll');
    // doua cadre: primul face elementul masurabil, al doilea porneste tranzitia
    requestAnimationFrame(() => requestAnimationFrame(() => {
      root.classList.add('is-in');
      input.focus({ preventScroll: true });
    }));
  };

  const close = () => {
    if (root.hidden) return;
    root.classList.remove('is-in');
    document.documentElement.classList.remove('bk-noscroll');
    const done = () => {
      root.hidden = true;
      sheet.removeEventListener('transitionend', done);
    };
    sheet.addEventListener('transitionend', done);
    // plasa de siguranta: daca utilizatorul are animatiile oprite, `transitionend` nu vine
    setTimeout(done, 400);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-bk-srch-open]');
    if (!t) return;
    e.preventDefault();
    open(t);
  });

  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });

  /* ------------------------------------------------------------- sugestii */

  const show = (html) => {
    res.innerHTML = html;
    res.hidden = false;
    idle.hidden = true;
  };
  const showIdle = () => {
    res.hidden = true;
    res.innerHTML = '';
    idle.hidden = false;
  };

  const query = async (q) => {
    if (cache.has(q)) { show(cache.get(q)); return; }
    const mine = ++seq;
    show('<div class="bksrch__load" aria-hidden="true">' +
         '<span></span><span></span><span></span><span></span></div>');
    try {
      const url = '/search/suggest?q=' + encodeURIComponent(q) +
                  '&section_id=balkan-search-fragment' +
                  '&resources[type]=product,collection,query&resources[limit]=8';
      const r = await fetch(url);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const frag = doc.querySelector('[data-bk-srchfrag]');
      const html = frag ? frag.innerHTML : '';
      cache.set(q, html);
      if (mine === seq) show(html);
    } catch {
      // reteaua a picat: nu lasam un panou gol, formularul ramane trimisibil
      if (mine === seq) show('<p class="bksrch__none">Nu am putut cere sugestiile. ' +
                             'Apasă Enter ca să vezi toate rezultatele.</p>');
    }
  };

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { seq++; showIdle(); return; }
    timer = setTimeout(() => query(q), 220);
  });
})();
